import React, { Component, useState, useEffect, } from "react";
import SyncLoader from "react-spinners/SyncLoader";
import ItemDashboard from "./launchPadComp/itemDashboard";
import StakeLOTT from "./launchPadComp/stakeLott";
import Information from "./launchPadComp/information";
import TokenAd from "./launchPadComp/tokenAd";
import Tiers from "./HomeComp/tiers";
import Architecture from "./launchPadComp/architecture";
import Team from "./launchPadComp/team";

function LaunchPad() {

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true)
        setTimeout(() => {
            setLoading(false)
        }, 1500)
    }, [])

    return (

        <React.Fragment>

            {loading ?

                <div className="animation_widget">
                    <SyncLoader
                        loading={loading}
                        size={30}
                        color={"yellow"}
                    />
                </div>

                :

                <React.Fragment>
                    <ItemDashboard />
                    <StakeLOTT />
                    <Information />
                    <Tiers />
                    <TokenAd />
                    <Architecture />
                    <Team />
                </React.Fragment>

            }

        </React.Fragment>

    );

}

export default LaunchPad;